import React from 'react';
import { notification, Modal, Select } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../../common/Loading';

import getOrganismos from '../../../../graphql/querys/organismos/getOrganismos.graphql';

import getTalonariosPorOrganismo from '../../../../graphql/querys/otros/getTalonariosPorOrganismo.graphql';
import getTalonarios from '../../../../graphql/querys/otros/getTalonarios.graphql';
import deleteTalonario from '../../../../graphql/mutations/otros/deleteTalonario.graphql';
import getUsuario from '../../../../graphql/querys/auth/getUsuario.graphql';

import TablaTalonarios from './TablaTalonarios';
import { errorService } from '../../../../graphql/utils/utils';

const confirm = Modal.confirm;
@compose(
  // graphql(getTalonarios, { options: { fetchPolicy: "network-only" } }),
  graphql(getOrganismos, {
    name: 'getOrganismos',
    options: { fetchPolicy: 'network-only' },
  }),
  graphql(deleteTalonario, {
    name: 'deleteTalonario',
    options: {
      refetchQueries: [{ query: getTalonarios }],
    },
  }),
  graphql(getUsuario, {
    name: 'usuario',
  })
)
class VerTalonarios extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      talonarios: [],
    };

    this.onDelete = this.onDelete.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.usuario && !this.state.llamada) {
      this.cambiarOrganismo(nextProps.usuario.getUsuario.organismo._id);
    }
  }

  onDelete(id) {
    //TODO: Hacer el onDelete.

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este talonario?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteTalonario({
            variables: { _id: id },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Talonario eliminada',
              description: 'Se ha eliminado correctamente el talonario',
            });
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el talonario');
            console.log(err);
            errorService(err, {
              _id: id,
            });

            Modal.error({
              title: 'Error en la eliminacion del talonario',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  cambiarOrganismo = idOrganismo => {
    this.setState(
      {
        ...this.state,
        idOrganismo: idOrganismo,
      },
      () => {
        this.props.client
          .query({
            query: getTalonariosPorOrganismo,
            variables: { idOrganismo: idOrganismo },
            fetchPolicy: 'network-only',
          })
          .then(res => {
            const talonarios = res.data.getTalonariosPorOrganismo;
            // console.log("Respuesta exitosa!");
            // console.log(talonarios);

            this.setState({
              ...this.state,
              llamada: true,
              talonarios: talonarios,
            });
          })
          .catch(err => {
            console.log('Error en la creacion');
            console.log(err);
            errorService(err, {
              idOrganismo,
            });

            Modal.error({
              title: 'Error a la hora de buscar el stock en la base de datos',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  };

  render() {
    if (
      this.state.loading ||
      this.props.getOrganismos.loading ||
      this.props.usuario.loading
    ) {
      return <Loading />;
    }

    const { usuario } = this.props;

    return (
      <div>
        <h1 style={{ textAlign: 'center', marginTop: 15 }}>Administración</h1>
        <h2 style={{ textAlign: 'center', marginTop: 40 }}>
          TALONARIOS ACTUALES
        </h2>
        <h3 style={{ textAlign: 'center', marginTop: 20 }}>
          ORGANISMO:
          <Select
            style={{ width: 500, marginLeft: 10 }}
            id="organismos"
            placeholder="Seleccione el organismo"
            defaultValue={usuario.getUsuario.organismo._id}
            disabled={usuario.getUsuario.rol != 'SUPERVISOR'}
            onSelect={valor => this.cambiarOrganismo(valor)}
          >
            {this.props.getOrganismos.getOrganismos &&
              this.props.getOrganismos.getOrganismos.map(organismo => (
                <Select.Option key={organismo._id}>
                  {organismo.nombre}
                </Select.Option>
              ))}
          </Select>
        </h3>
        <TablaTalonarios
          talonarios={this.state.talonarios}
          history={this.props.history}
          onDelete={this.onDelete}
        />
      </div>
    );
  }
}

export default withApollo(VerTalonarios);
